"use client";

import { c as _c } from "react/compiler-runtime";
import { CSVViewer } from "@/src/components/csv-viewer/csv-viewer";
import { PDFViewer } from "@/src/components/pdf-viewer/pdf-viewer";
import { isCsvContentType } from "@/src/lib/utils/csv";
export function FileViewer(t0) {
  const $ = _c(9);
  const {
    url,
    filename,
    contentType,
    activePage,
    downloadDisabledReason
  } = t0;
  if (isCsvContentType(contentType)) {
    let t1;
    if ($[0] !== downloadDisabledReason || $[1] !== filename || $[2] !== url) {
      t1 = <CSVViewer url={url} filename={filename} downloadDisabledReason={downloadDisabledReason} />;
      $[0] = downloadDisabledReason;
      $[1] = filename;
      $[2] = url;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== activePage || $[5] !== downloadDisabledReason || $[6] !== filename || $[7] !== url) {
    t1 = <PDFViewer key={url} url={url} filename={filename} activePage={activePage} downloadDisabledReason={downloadDisabledReason} />;
    $[4] = activePage;
    $[5] = downloadDisabledReason;
    $[6] = filename;
    $[7] = url;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}